var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoundLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19999 24C0.927096 24 0.705872 23.7345 0.705872 23.4071L0.705872 14.7106C0.705872 14.3831 0.927096 14.1176 1.19999 14.1176L5.15293 14.1176C5.42582 14.1176 5.64705 14.3831 5.64705 14.7106L5.64705 23.4071C5.64705 23.7345 5.42582 24 5.15293 24L1.19999 24ZM1.69411 22.8141L4.65881 22.8141L4.65881 15.3035L1.69411 15.3035L1.69411 22.8141Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84705 24C6.57416 24 6.35294 23.7577 6.35294 23.4588L6.35294 8.30588C6.35294 8.007 6.57416 7.76471 6.84705 7.76471L10.8 7.76471C11.0729 7.76471 11.2941 8.007 11.2941 8.30588L11.2941 23.4588C11.2941 23.7577 11.0729 24 10.8 24L6.84705 24ZM7.34117 22.9176L10.3059 22.9176L10.3059 8.84706L7.34117 8.84706L7.34117 22.9176Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.436 24C12.1952 24 12 23.752 12 23.4462L12 0.553846C12 0.247965 12.1952 0 12.436 0L16.5052 1.25535e-10C16.746 1.32243e-10 16.9412 0.247965 16.9412 0.553846L16.9412 23.4462C16.9412 23.752 16.746 24 16.5052 24L12.436 24ZM12.872 22.8923L16.0692 22.8923L16.0692 1.10769L12.872 1.10769L12.872 22.8923Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1453 24C17.8701 24 17.6471 23.7562 17.6471 23.4555L17.6471 11.8387C17.6471 11.5379 17.8701 11.2941 18.1453 11.2941L22.7959 11.2941C23.071 11.2941 23.2941 11.5379 23.2941 11.8387L23.2941 23.4555C23.2941 23.7562 23.071 24 22.7959 24L18.1453 24ZM18.6436 22.9109L22.2976 22.9109L22.2976 12.3832L18.6436 12.3832L18.6436 22.9109Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundLevel);
export default __webpack_public_path__ + "static/media/SoundLevel.85288d09131fd9b8dc009f837aa189b9.svg";
export { ForwardRef as ReactComponent };